import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { combineLatest } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AuxiliaryDataModule } from '../../auxiliary-data.module';
import { AuxiliaryDataTableComponent } from '../auxiliary-data-table/auxiliary-data-table.component';

@Component({
  imports: [CommonModule, MatDialogModule, AuxiliaryDataModule, MatButtonModule, TranslateModule],
  template: `
    <h1 mat-dialog-title>{{ 'COMMON.MANAGE_ATTRIBUTES' | translate }}</h1>
    <mat-dialog-content>
      <aux-auxiliary-data-table
        #auxiliarydatatable
        [partnerId]="partnerId"
        [objectType]="objectTypeId$ | async"
        [objectId]="objectId$ | async"
        [disableManage]="disableManage$ | async"
        auxiliaryDataAdminURL="/custom-fields?objectType={{ objectTypeId$ | async }}"
      ></aux-auxiliary-data-table>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-flat-button (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onSave()">Save</button>
    </mat-dialog-actions>
  `,
})
class InnerDialogComponent {
  private readonly data = inject(MAT_DIALOG_DATA);
  public readonly partnerId = this.data.partnerId;
  public readonly objectTypeId$ = this.data.objectTypeId$;
  public readonly objectId$ = this.data.objectId$;
  public readonly disableManage$ = this.data.disableManage$;
  private readonly ref = inject(MatDialogRef);
  private readonly snackbar = inject(SnackbarService);

  @ViewChild('auxiliarydatatable')
  private auxiliaryDataTable: AuxiliaryDataTableComponent;

  onCancel() {
    this.ref.close();
  }

  async onSave() {
    try {
      await this.auxiliaryDataTable.saveChanges().toPromise();
      this.ref.close();
    } catch (e) {
      this.snackbar.openErrorSnack('An error occured. Changes were not saved.');
    }
  }
}

@Component({
  standalone: true,
  template: ``,
})
export class CustomFieldsDialogComponent implements OnInit {
  dialog = inject(MatDialog);
  router = inject(Router);
  route = inject(ActivatedRoute);

  ngOnInit() {
    const ref = this.dialog.open(InnerDialogComponent, {
      width: '80%',
      data: {
        partnerId: this.route.snapshot.params.partnerId,
        objectTypeId$: this.route.params.pipe(map((params) => params.objectTypeId)),
        objectId$: this.route.params.pipe(map((params) => params.objectId)),
        disableManage$: this.route.params.pipe(map((params) => params.disableManage === 'true')),
      },
    });
    combineLatest([this.route.queryParams.pipe(first()), ref.afterClosed()]).subscribe(([queryParams]) => {
      this.router.navigate([{ outlets: { action: null } }], { queryParams });
    });
  }
}
